var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper active",
      staticStyle: { display: "block" },
      attrs: { tabindex: "0" }
    },
    [
      _c(
        "div",
        {
          ref: "layerBox",
          staticClass: "cbox layerBox popWidM",
          style: Object.assign(
            {},
            { display: "block", opacity: "1" },
            _vm.style
          )
        },
        [
          _c(
            "div",
            { staticClass: "cart-popup__dialog NCACroa_cont02_popUp" },
            [
              _vm.showHeader
                ? _c("div", { staticClass: "cart-popup__header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "cart-popup__header-text",
                        staticStyle: { color: "#2c2c2c" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.headerText) +
                            "\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "cart-popup__close",
                            attrs: {
                              "data-dismiss": "modal",
                              "aria-label": "Close",
                              "aria-hidden": "true"
                            },
                            on: { click: _vm.closePopup }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/views/survey/images/NCACroatia_close.png"),
                                alt: "닫기"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.content
                ? _c("div", {
                    staticClass: "cart-popup__content payment",
                    domProps: { innerHTML: _vm._s(_vm.content) }
                  })
                : _c("div", { staticClass: "cart-popup__content payment" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cart-popup__item-info amway-theme",
                        staticStyle: { padding: "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "os_noticeRes" },
                          _vm._l(_vm.activityContent, function(content) {
                            return _c("SurveyPicture", {
                              key: content.image,
                              attrs: {
                                src: require("../images/" + content.image),
                                alt:
                                  "2022 크로아티아 다이아몬드 인비테이셔널 - 액티비티 정보 안내",
                                description: content.description
                              },
                              on: { "load:image": _vm.layerTypeBasic }
                            })
                          }),
                          1
                        )
                      ]
                    )
                  ]),
              _vm._v(" "),
              _vm.showConfirmBtn
                ? _c(
                    "div",
                    {
                      staticClass: "cart-popup__item-link",
                      staticStyle: { border: "none" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "bt-akl-blue btn_close NCACroa_cont03_popup",
                          on: { click: _vm.closePopup }
                        },
                        [_vm._v("확인")]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-577b29dd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577b29dd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/components/SurveyPopupLayer.vue
// module id = null
// module chunks = 